import React, { useState } from "react";
const uniqid = require('uniqid');

const TextInput = (props) => {
	const {
		label = "Suchbegriff",
		placeholder = "Suchbegriff eingeben",
		value = "",
		onChange, // passes new value
		onEnter,
	} = props;

	const [ id ] = useState(uniqid('textinput-'));
	const placeholderId = id + "-placeholder";
	const inputId = id + "-input";

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			onEnter();
		}
	};

	return (
		<div className="listbox-area fullwidth textinput">
			<div className="left-area">
				<span className="exp_elem" id={ placeholderId }>{ label }</span>
				<div className="exp_wrapper">
					<input className="exp_button" type="text" value={ value } placeholder={ placeholder }
						aria-labelledby={ placeholderId + " " + inputId } id={ inputId }
						onChange={ e => onChange(e.currentTarget.value) }
						onKeyDown={ handleKeyDown }
						autoComplete="off" />
				</div>
			</div>
		</div>
	);
};

export default TextInput;
